/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Create_Aaf_FailedInputs */

const en_subtitle_export_create_aaf_failed = /** @type {(inputs: Subtitle_Export_Create_Aaf_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There was an error creating the AAF file.`)
};

const fr_subtitle_export_create_aaf_failed = /** @type {(inputs: Subtitle_Export_Create_Aaf_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite lors de la création du fichier AAF.`)
};

const de_subtitle_export_create_aaf_failed = /** @type {(inputs: Subtitle_Export_Create_Aaf_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Erstellen der AAF-Datei ist ein Fehler aufgetreten.`)
};

const it_subtitle_export_create_aaf_failed = /** @type {(inputs: Subtitle_Export_Create_Aaf_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore durante la creazione del file AAF.`)
};

const ru_subtitle_export_create_aaf_failed = /** @type {(inputs: Subtitle_Export_Create_Aaf_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Произошла ошибка при создании файла AAF.`)
};

const es_subtitle_export_create_aaf_failed = /** @type {(inputs: Subtitle_Export_Create_Aaf_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se produjo un error al crear el archivo AAF.`)
};

const zh_cn2_subtitle_export_create_aaf_failed = /** @type {(inputs: Subtitle_Export_Create_Aaf_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建 AAF 文件时出错。`)
};

const ja_subtitle_export_create_aaf_failed = /** @type {(inputs: Subtitle_Export_Create_Aaf_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF ファイルの作成中にエラーが発生しました。`)
};

const hi_subtitle_export_create_aaf_failed = /** @type {(inputs: Subtitle_Export_Create_Aaf_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF फाइल बनाने में त्रुटि हुई।`)
};

const pt_pt2_subtitle_export_create_aaf_failed = /** @type {(inputs: Subtitle_Export_Create_Aaf_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro ao criar o arquivo AAF.`)
};

/**
* | output |
* | --- |
* | "There was an error creating the AAF file." |
*
* @param {Subtitle_Export_Create_Aaf_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_create_aaf_failed = /** @type {((inputs?: Subtitle_Export_Create_Aaf_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Create_Aaf_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_create_aaf_failed(inputs)
	if (locale === "de") return de_subtitle_export_create_aaf_failed(inputs)
	if (locale === "it") return it_subtitle_export_create_aaf_failed(inputs)
	if (locale === "ru") return ru_subtitle_export_create_aaf_failed(inputs)
	if (locale === "es") return es_subtitle_export_create_aaf_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_create_aaf_failed(inputs)
	if (locale === "ja") return ja_subtitle_export_create_aaf_failed(inputs)
	if (locale === "hi") return hi_subtitle_export_create_aaf_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_create_aaf_failed(inputs)
	return en_subtitle_export_create_aaf_failed(inputs)
});